// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".look-section{padding:24px 0 128px}.look-section .look-image{height:auto;margin-bottom:56px;max-width:100%}@media (min-width:1024px){.look-section .look-image{margin-bottom:0}}.look-section .look-products{margin-top:56px}@media (min-width:1024px){.look-section .look-products{margin-top:42px}}.look-section .look-products .product-card{margin-bottom:40px}", ""]);
// Exports
module.exports = exports;
